import {OrderDeliveryStatus} from "~/types/orders/OrdersCategories";
import {OrderItem} from "~/modules/GraphQL/types";

function getOrderItemStatus(orderItem: OrderItem): string {
  if (orderItem.quantity_invoiced === 0 && orderItem.quantity_shipped === 0 && orderItem.quantity_canceled === 0) {
    return OrderDeliveryStatus.ORDERED
  }

  if (orderItem.quantity_invoiced === orderItem.quantity_ordered && orderItem.quantity_shipped === 0 &&
    (orderItem.quantity_canceled === 0 || orderItem.quantity_canceled === null)) {
    return OrderDeliveryStatus.INVOICED
  }

  if (orderItem.quantity_invoiced === orderItem.quantity_ordered && orderItem.quantity_shipped === orderItem.quantity_ordered) {
    return OrderDeliveryStatus.COMPLETE
  }

  if (orderItem.quantity_shipped === orderItem.quantity_ordered) {
    return OrderDeliveryStatus.COMPLETE
  }

  if (orderItem.quantity_ordered === orderItem.quantity_canceled) {
    return OrderDeliveryStatus.CANCELED
  }

  if (orderItem.quantity_shipped > 0 && orderItem.quantity_ordered > orderItem.quantity_shipped) {
    return OrderDeliveryStatus.PARTIAL_SHIPPED
  }

  if (orderItem.quantity_canceled > 0 && orderItem.quantity_ordered > orderItem.quantity_canceled) {
    return OrderDeliveryStatus.PARTIAL_CANCELED
  }


}

const orderStatusGetter = {
  getOrderItemStatus
}

export default orderStatusGetter;
